import {downloadDatabaseById} from "./databases-service";

export const downloadDB = (id = 0, name = "database") => {
	return (
		downloadDatabaseById( id )
			.then( blob => {
				if (!(blob instanceof Blob)) {
					window.alert(`Impossibile scaricare il database "${ name }": non è più disponibile.`);
					return;
				}

				//@ts-ignore
				if (window.navigator && window.navigator?.msSaveOrOpenBlob) {
					//@ts-ignore
					window.navigator?.msSaveOrOpenBlob(blob);
					return;
				}
				const objUrl = window.URL.createObjectURL(blob);

				let link = document.createElement('a');
				link.href = objUrl;
				link.download = `${ name }.db`;
				link.click();

				// For Firefox it is necessary to delay revoking the ObjectURL.
				setTimeout(() => {
					window.URL.revokeObjectURL(objUrl);
				}, 250);
			})
			.catch( e => Promise.reject( e ) )
	);
}
